export const chartDays = [
  {
    label: '1D',
    value: 1,
  },
  {
    label: '7D',
    value: 7,
  },
  {
    label: '30D',
    value: 30,
  },
  {
    label: '3M',
    value: 90,
  },
  {
    label: '1Y',
    value: 365,
  },
];
